import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "qr-code, barcode, scan" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M11.2498 11.2493V13.7493H13.7498M14.5832 11.2493H17.0832M17.0832 14.5827H14.5832V17.0827M11.2498 17.0827V16.2493M8.74984 2.91602H2.9165V8.74935H8.74984V2.91602ZM2.9165 11.2493H8.74984V17.0827H2.9165V11.2493ZM11.2498 2.91602H17.0832V8.74935H11.2498V2.91602Z",
        stroke: "#007AFF",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }